import React from 'react';

import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';

import useStyles from '../../styles';

import Init from './Init';
import Choose from './Choose';
import Description from './Description';

const Details = ({
  path,
  setPath,
  detailData,
  chooseData,
  updateDeliveryVehicle,
  updateDeliveryStatus,
  bulkUpdateDeliveryStatus,
  isBusy
}) => {

  const classes = useStyles();

  const Switch = () => {
    switch(path) {
      case 'detail': return <Description data={detailData.slotData} {...{detailData, setPath}}/>;
      case 'choose': return <Choose action={updateDeliveryVehicle}
        {...{isBusy, chooseData, setPath}}/>;
      case 'start': return <Choose action={bulkUpdateDeliveryStatus}
        {...{isBusy, chooseData, setPath}}/>;
      case 'init': return <Init {...{updateDeliveryStatus, setPath}}/>;
      default: return <CircularProgress/>;
    }
  };

  return <Dialog
    open={path !== 'root'}
    onClose={() => setPath('root')}
    maxWidth='xl'
    fullWidth
    scroll='body'
  >
    <Paper className={classes.dialog}>
      <Grid container justify='space-around' alignItems='center'>
        <Switch/>
      </Grid>
    </Paper>
  </Dialog>;
};

export default Details;
